"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DereferenceCachePolicyHttpWrapper = void 0;
const ActorDereferenceHttpBase_1 = require("./ActorDereferenceHttpBase");
/**
 * A wrapper around an HTTP request cache policy that exposes it as a dereference cache policy.
 */
class DereferenceCachePolicyHttpWrapper {
    cachePolicy;
    maxAcceptHeaderLength;
    constructor(cachePolicy, maxAcceptHeaderLength) {
        this.cachePolicy = cachePolicy;
        this.maxAcceptHeaderLength = maxAcceptHeaderLength;
    }
    storable() {
        return this.cachePolicy.storable();
    }
    async satisfiesWithoutRevalidation(action) {
        return this.cachePolicy.satisfiesWithoutRevalidation({
            input: action.url,
            init: {
                headers: await ActorDereferenceHttpBase_1.ActorDereferenceHttpBase.establishAcceptHeader(action, this.maxAcceptHeaderLength),
                method: action.method,
            },
            context: action.context,
        });
    }
    responseHeaders() {
        return this.cachePolicy.responseHeaders();
    }
    timeToLive() {
        return this.cachePolicy.timeToLive();
    }
    async revalidationHeaders(newAction) {
        return this.cachePolicy.revalidationHeaders({
            input: newAction.url,
            init: {
                headers: await ActorDereferenceHttpBase_1.ActorDereferenceHttpBase.establishAcceptHeader(newAction, this.maxAcceptHeaderLength),
                method: newAction.method,
            },
            context: newAction.context,
        });
    }
    async revalidatedPolicy(revalidationAction, revalidationResponse) {
        const revalidatedPolicy = await this.cachePolicy.revalidatedPolicy({
            input: revalidationAction.url,
            init: {
                headers: await ActorDereferenceHttpBase_1.ActorDereferenceHttpBase.establishAcceptHeader(revalidationAction, this.maxAcceptHeaderLength),
                method: revalidationAction.method,
            },
            context: revalidationAction.context,
        }, revalidationResponse);
        return {
            policy: new DereferenceCachePolicyHttpWrapper(revalidatedPolicy.policy, this.maxAcceptHeaderLength),
            modified: revalidatedPolicy.modified,
            matches: revalidatedPolicy.matches,
        };
    }
}
exports.DereferenceCachePolicyHttpWrapper = DereferenceCachePolicyHttpWrapper;
//# sourceMappingURL=DereferenceCachePolicyHttpWrapper.js.map